"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translations = require("../../helpers/translations");

var _material = require("@mui/material");

var _InfoIcon = _interopRequireDefault(require("../InfoIcon"));

require("./SearchIcon.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchIcon, _React$Component);

  var _super = _createSuper(SearchIcon);

  function SearchIcon(props) {
    var _this;

    _classCallCheck(this, SearchIcon);

    _this = _super.call(this, props);
    _this.state = {
      term: '',
      open: false
    };
    _this.onSearchTermChange = _this.onSearchTermChange.bind(_assertThisInitialized(_this));
    _this.toggleInput = _this.toggleInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchIcon, [{
    key: "onSearchTermChange",
    value: function onSearchTermChange(term) {
      this.setState({
        term: term
      });
      this.props.onSearchSubmit(term);
    }
  }, {
    key: "toggleInput",
    value: function toggleInput() {
      var _this2 = this;

      this.setState({
        open: !this.state.open
      }, function () {
        if (_this2.state.open) {
          _this2.searchInput.focus();
        } else {
          _this2.onSearchTermChange('');
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "SearchIcon_container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.open ? 'SearchIcon_textBoxContainerOpen' : 'SearchIcon_textBoxContainerClosed'
      }, this.props.showSearchTips && this.state.open ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "SearchIcon_infoIcon"
      }, /*#__PURE__*/_react["default"].createElement(_InfoIcon["default"], {
        message: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "SearchIcon_searchTipsTitle"
        }, (0, _translations.getTranslations)('searchicon_head')), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _translations.getTranslations)('searchicon_quotations_head'), "\xA0"), /*#__PURE__*/_react["default"].createElement("span", null, (0, _translations.getTranslations)('searchicon_quotations_1_text'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("i", null, (0, _translations.getTranslations)('searchicon_quotations_2_text'), "\"", (0, _translations.getTranslations)('searchicon_quotations_3_text'), "\""))), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _translations.getTranslations)('searchicon_filter_head'), "\xA0"), /*#__PURE__*/_react["default"].createElement("span", null, (0, _translations.getTranslations)('searchicon_filter_1_text'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("i", null, (0, _translations.getTranslations)('searchicon_filter_2_text'))))),
        position: "bottom"
      })) : null, /*#__PURE__*/_react["default"].createElement("input", {
        ref: function ref(input) {
          _this3.searchInput = input;
        },
        className: "SearchIcon_input",
        placeholder: (0, _translations.getTranslations)('search_enter_term_text'),
        value: this.state.term,
        onChange: function onChange(e) {
          return _this3.onSearchTermChange(e.target.value);
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.term.length > 0 ? 'SearchIcon_clearInputIconShow' : 'SearchIcon_clearInputIconHide',
        onClick: function onClick() {
          return _this3.onSearchTermChange('');
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "SearchIcon_clearInputIcon"
      }, "clear")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.open ? 'SearchIcon_iconContainerOpen' : 'SearchIcon_iconContainerClosed',
        onClick: this.toggleInput
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, {
        style: {
          fontSize: '28px'
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: this.state.open ? 'SearchIcon_searchIconInverse' : 'SearchIcon_searchIcon'
      }, "search"))));
    }
  }]);

  return SearchIcon;
}(_react["default"].Component);

_defineProperty(SearchIcon, "propTypes", {
  onSearchSubmit: _propTypes["default"].func.isRequired,
  showSearchTips: _propTypes["default"].bool
});

_defineProperty(SearchIcon, "defaultProps", {
  showSearchTips: true
});

var _default = SearchIcon;
exports["default"] = _default;